import 'twin.macro';
import React, { useRef } from 'react';
import Dialog from '@teetsh/app/src/components/Dialog';
import { useIsSearchOpen, useToggleSearchModal } from './atom';
import useKeyPress from './useKeyPress';
import { GlobalSearch } from '.';

export function GlobalSearchModal() {
  const open = useIsSearchOpen();
  const toggleSearchModal = useToggleSearchModal();
  useKeyPress(['k'], () => toggleSearchModal(true));
  const inputRef = useRef(null);
  return (
    <Dialog
      isOpen={open}
      onClose={() => {
        toggleSearchModal(false);
      }}
      size="2xl"
      closeButton
      disabledClickOutside={false}
      initialFocus={inputRef}
      position="top"
      zIndex="30"
    >
      <Dialog.Body tw="bg-white p-0 flex flex-col">
        <GlobalSearch inputRef={inputRef} />
      </Dialog.Body>
    </Dialog>
  );
}
